export const firebaseConfig = {
  apiKey: "AIzaSyCx9HEmUqV_aaqiqC6EVa73vWMB9Zk_a_k",
  authDomain: "imgs-german-site.firebaseapp.com",
  databaseURL: "https://imgs-german-site.firebaseio.com",
  projectId: "imgs-german-site",
  storageBucket: "imgs-german-site.appspot.com",
  messagingSenderId: "570171886493",
  appId: "1:570171886493:web:580e228f8c4c726abd7d74",
  measurementId: "G-3NTB4F3RSG",
};

export default firebaseConfig;
